{
  "deprecatedBrowser": "Votre navigateur n’est pas pris en charge",
  "deprecatedBrowserHelpText": "Pensez à mettre à jour votre navigateur vers la dernière version pour vivre la meilleure expérience possible."
}
